import { Nullable } from '@tcc/common';
import { Maybe, UapiFieldRegionHarvestStats, UapiMeasure } from '../../../../../../graphql/sdk';
import { ReportMeasurement } from '../../../../../../types';
import { ArdFieldRegionReportBaseStats } from '../../../../../../types/FieldRegionReport';
import { MOISTURE_PERCENT_DEFAULT_UNIT, NOMINAL_WEIGHT_DEFAULT_UNIT } from './constants';

export const adaptMeasurement = (
  measurement: Maybe<UapiMeasure> | undefined, defaultUnit: string
): Nullable<ReportMeasurement> => {
  if (!measurement) {
    return null;
  }

  return {
    v: measurement.v,
    u: measurement.u ?? defaultUnit
  };
};


export const adaptMetricStats = (stats: UapiFieldRegionHarvestStats): ArdFieldRegionReportBaseStats => ({
  dryMass: adaptMeasurement(stats?.dryMass, 'kg'),
  harvestedArea: adaptMeasurement(stats?.harvestedArea, 'ha'),
  moistureMass: adaptMeasurement(stats?.moistureMass, 'kg'),
  moisturePercent: adaptMeasurement(stats?.moisturePercent, MOISTURE_PERCENT_DEFAULT_UNIT),
  nominalWeight: adaptMeasurement(stats?.nominalWeight, NOMINAL_WEIGHT_DEFAULT_UNIT),
  stdYield: adaptMeasurement(stats?.stdYield, 'kg/ha'),
  wetMass: adaptMeasurement(stats?.wetMass, 'kg'),
});
